export default __webpack_public_path__ + "static/feature_01-674b7431badeaf5d9abd9a35fd46ff7c.png";